import gettext from '@sdk/lang/gettext';
import { GroupedPersonaPicker } from '@sdk/components/forms/personaPickers/GroupedPersonaPicker/GroupedPersonaPicker';
import FieldLabel from '@sdk/components/forms/components/FieldLabel';

import {
  MembersField,
  RestrictedToUsersField as RestrictedToUsersFieldType,
} from '@web/conversations/types/ConversationFields';
import { FieldWrapper } from '@web/conversations/ComposeConversation/composeConversation.styles';

import { useRestrictedToUsersField } from './restrictedToUsersField.hooks';

type Props = {
  hasError?: boolean;
  members: MembersField;
  restrictedToUsers: RestrictedToUsersFieldType;
};

export const RestrictedToUsersField = ({ hasError, members, restrictedToUsers }: Props) => {
  const { options } = useRestrictedToUsersField(members);

  return (
    <FieldWrapper>
      <FieldLabel
        label={gettext('specified users')}
        htmlFor="conversation-restricted-to-users"
        invalid={hasError}>
        <GroupedPersonaPicker
          hasError={hasError}
          id="conversation-restricted-to-users"
          options={options}
          selectedItems={restrictedToUsers.value}
          onSelectedItemsChange={restrictedToUsers.onChange}
          placeholder={gettext('Add employees')}
        />
      </FieldLabel>
    </FieldWrapper>
  );
};
